module.exports = "<top-bar color='black' [orgId]='orgId'></top-bar>\n<div class=\"container center\">\n  <img src='/assets/img/bluestars.png'>\n  <h1 class=\"blue\">Thank you for registering with Rise Small Business!</h1>\n  <p>Our onboarding team will be in touch with you within 5 business days to complete your registration.</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/onboarding/components/onboarding-success-page/onboarding-success-page.component.html
// module id = ./src/app/onboarding/components/onboarding-success-page/onboarding-success-page.component.html
// module chunks = main